module.exports = __webpack_public_path__ + "static/shape-06-845fe31c758cd8e647f712525c727ba4.svg";